/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { ReactElement } from "react";
import styled from "styled-components";
import { green, gray } from "../../helperFunctions/styledComponents";

interface ToggleProps {
  disabled: boolean;
  checked: boolean;
  name: string;
  id: string;
  onChange: (checked: boolean) => void;
}

interface StyledToggleProps {
  disabled: boolean;
  checked: boolean;
  tabIndex: number;
  onKeyDown: (checked: boolean) => void;
}

declare const brandColor: string;

const StyledInner = styled.span`
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.1s ease-in 0s;
  &:before,
  &:after {
    display: block;
    float: left;
    width: 50%;
    height: 30px;
    padding: 0;
    line-height: 30px;
    font-size: 14px;
    color: white;
    font-weight: bold;
    box-sizing: border-box;
  }
  &:before {
    content: "";
    padding-left: 10px;
    background-color: ${brandColor};
    color: #fff;
  }
  &:after {
    content: "";
    padding-right: 10px;
    background-color: ${gray};
    color: #fff;
    text-align: right;
  }
`;

const StyledSwitch = styled.span`
  display: block;
  width: 24px;
  margin: 3px;
  background: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 23px;
  border: 0 solid ${gray};
  border-radius: 20px;
  transition: all 0.1s ease-in 0s;
  box-shadow: 0 3px 6px rgba(46, 53, 56, 0.33);
`;

const StyledToggle = styled.div`
  position: relative;
  width: 54px;
  display: inline-block;
  vertical-align: middle;
  user-select: none;
  text-align: left;
  input {
    display: none;
  }
  label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 0 solid ${gray};
    border-radius: 20px;
    margin: 0;
  }
  ${(p: StyledToggleProps): string => {
    return (
      p.disabled &&
      `
        background-color: #ddd;
        cursor: not-allowed;
        &:before {
        background-color: #ddd;
        cursor: not-allowed;
        }
    `
    );
  }}

  ${(p: StyledToggleProps): string => {
    return (
      p.checked &&
      `
    ${StyledInner} {
      margin-left: 0;
    }
    ${StyledSwitch} {
      right: 0px;
    }
    `
    );
  }}
`;

const Toggle = ({
  disabled,
  checked,
  name,
  id,
  onChange,
}: ToggleProps): ReactElement => {
  const handleKeyPress = (e): void => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    onChange(!checked);
  };
  return (
    <StyledToggle
      disabled={disabled}
      checked={checked}
      tabIndex={disabled ? -1 : 1}
      onKeyDown={(e): void => {
        return handleKeyPress(e);
      }}
    >
      <label htmlFor={name}>
        <input
          type="checkbox"
          name={name}
          id={id}
          checked={checked}
          disabled={disabled}
          onChange={(e): void => {
            return onChange(e.target.checked);
          }}
        />
        <StyledInner />
        <StyledSwitch />
      </label>
    </StyledToggle>
  );
};

export default Toggle;
